// break point用。値はsrc/assets/style/val.scssを参考
export default {
  SP_BREAK_POINT: 480,
  PC_BREAK_POINT: 1024,
}
